var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_vm._v(" "+_vm._s(_vm.emptyText())+" "),_c('button',{staticClass:"full_btn list_btn",on:{"click":_vm.runResetFilter}},[_vm._v("목록")])])
}
var staticRenderFns = []

export { render, staticRenderFns }